// @ts-expect-error Untyped Dependency
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import VizExSmall from 'visitor-ui-component-library/typography/VizExSmall';
import FriendlySenderName from './FriendlySenderName';
import { NEUTRAL_800 } from 'visitor-ui-component-library/constants/WidgetColors';
import { jsx as _jsx } from "react/jsx-runtime";
class SenderHeaderContent extends PureComponent {
  render() {
    const {
      isSenderLoading,
      sender
    } = this.props;
    if (isSenderLoading) {
      return /*#__PURE__*/_jsx(SkeletonText, {
        inlineSize: "150px"
      });
    }
    return /*#__PURE__*/_jsx(VizExSmall, {
      style: {
        color: NEUTRAL_800
      },
      use: "help",
      children: /*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx(FriendlySenderName, {
          sender: sender
        })
      })
    });
  }
}
SenderHeaderContent.displayName = 'SenderHeaderContent';
SenderHeaderContent.propTypes = {
  isSenderLoading: PropTypes.bool,
  sender: RecordPropType('Sender')
};
export default SenderHeaderContent;